import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-confirm-popup",
  template: `
    <div class="primary-container-s">
      <div class="header">{{ header }}</div>
      <div class="description">{{ description }}</div>
      <div class="actions button-row justify-content-end">
        <button class="tertiary-small" (click)="cancel()">Cancel</button>
        <button class="error-small" (click)="confirm()">Delete Event</button>
      </div>
    </div>
  `,
  styles: [
    `
      .header {
        font-size: 16px;
        color: #2a3962;
        margin-bottom: 8px;
        font-weight: bold;
        line-height: 19px;
      }
    `,
    `
      .description {
        font-size: 16px;
        color: #2a3962;
        margin-bottom: 32px;
      }
    `,
    `
      .actions {
        margin-top: 16px;
      }
    `
  ]
})
export class ConfirmPopupComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<ConfirmPopupComponent>) {}

  ngOnInit(): void {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  public get header(): string {
    return "Are you sure you want to delete this event?";
  }
  public get description(): string {
    return "You can't undo this action.";
  }
}
